<template>
  <div class="bbsinfo">
    <div class="pageTitle">论坛帖子详情</div>
    <div class="toppicbox" v-if="info&&info.video">
      <video :src="info.video" height="100%" width="100%" controls="controls" controlslist="nodownload noremoteplayback" :poster="img.default">
      </video>
    </div>
    <div v-if="imgnum>0">
      <van-swipe class="toppicbox" :show-indicators="false" @change="changeimg">
        <van-swipe-item v-for="(item,index) in imglist" :key="'swipe_'+index">
          <img  class="topimg" v-lazy="item" @click="showImg(index,1)">
        </van-swipe-item>
      </van-swipe>
      <div class="piclength">{{imgindex}}/{{imgnum}}</div>
    </div>
    <div class="show" v-if="info">
      <van-row type="flex" justify="space-between" v-if="info.user">
        <van-col span="3">
          <div class="infohand_box">
            <img class="listhand" :src="info.user.headimg_url&&info.user.headimg_url.substring(0,5)=='https' ? info.user.headimg_url : img.avatar">
            <img class="infohand_border" :src="img.border_pic" v-if="info.user.auth.is_audit==1">
          </div>
        </van-col>
        <van-col class="ml-10 discenter" span="16" @click="goMy(info.user.id)">
          <div v-if="info.user.cars.id">
            <div class="membername">
              {{info.user.user_name}}
            </div>
            <div v-if="info.user.cars.id" class="sourtime" style="display: flex;align-items: center;">
              <img class="member_car" :src="img.member_car">
              {{info.user.cars.title}} 车主
            </div>
        <!-- <div v-if="info.user.intro" class="sourtime">
          {{info.user.intro}}
        </div> -->
      </div>
      <div v-else class="activename">
        {{info.user.user_name}}
      </div>
    </van-col>
    <van-col span="5"></van-col>
  </van-row>
  <!-- <van-divider /> -->
  <h1 v-if="info.title">{{ info.title }}</h1>
  <p>{{ info.content }}</p>
  <div v-if="info.cover">
    <div v-for="(img, index) in info.image" :key="'img_' + index">
      <img class="img" v-lazy="img" @click="showImg(index,1)" />
    </div>
  </div>
  <div v-else>
    <div v-for="(img, index) in info.image" :key="'img_' + index">
      <img class="img" v-if="index>0" v-lazy="img" @click="showImg(index,1)" />
    </div>
  </div>
  <div class="tag" v-if="info.topics.length>0">
    <van-tag v-for="t in info.topics" :key="'tag_' + t.id + '_id_' + info.id" color="#F3F9FF" text-color="#728FC4">#{{t.name}}#</van-tag>
  </div>
</div>
<div class="bbsbottom">
  <span @click="adminDel()">管理员删除</span>
  <span @click="adminAudit(1)">审核通过</span>
  <span @click="adminAudit(2)">审核不通过</span>
</div>
<van-image-preview
v-model="showState"
:images="imagelist"
:startPosition="imgIndex"
lazyLoad
@change="changeImg"
>
<template v-slot:index>
  {{ imgIndex + 1 }}/{{ imagelist.length }}
</template>
</van-image-preview>
</div>
</template>
<script>
  import bbs from '../../api/bbs';
  import admin from '../../api/admin';
  import { mapState } from 'vuex';
  import {Swipe, SwipeItem,List, Row, Col, Tab, Tabs, Tag, Button,Divider,Grid,GridItem,Field,Icon,Overlay,ImagePreview,Lazyload,ActionSheet,Dialog,Toast} from "vant";
  export default {
    data () {
      return {
        bbs_id: 0,
        
        info: '',
        comments: [],
        images:[],
        imglist:[],
        imagelist:[],
        imgIndex:0,
        showState:false,
        shareshow:false,
        imgnum:0,
        imgindex:1,
        img: {
          avatar: require('../../assets/img/lexus/default.png'),
          default: require('../../assets/img/default_lexus.png'),
          member_car: require('../../assets/img/member_car.png'),
          border_pic:require('../../assets/img/lexus/border.gif'),
        }
      }
    },
    
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      let id = this.$route.params.id
      this.bbs_id = id
      this.getInfo()
      if(localStorage.getItem('adminToken')){
        var newTime = new Date();
        var Year = newTime.getFullYear()
        var Month = newTime.getMonth() + 1
        var Day = newTime.getDate() 
        var LoginTime=Year.toString()+Month.toString()+Day.toString()
        var localLoginTime=localStorage.getItem('LoginTime')
        if(LoginTime==localLoginTime){
          
        }else{
          this.$router.push({name:'AdminLogin'});
        }
        
      }else{
        this.$router.push({name:'AdminLogin'});
      }
    },
    watch: {
     '$route'() {
      if(this.$route.params.id){
        if(this.$route.params.id != this.bbs_id) {
          this.bbs_id = this.$route.params.id
          this.getInfo()
        }
      }
      
    }
  },
  activated () {

  },
  methods: {
    getInfo () {
      bbs.getShow(this.bbs_id).then(res => {
        if(res.data.state == 1) {
          this.info = res.data.data
          this.$util.title(res.data.data.title)
          
          this.images = []
          for(let i of res.data.data.image) {
            this.images.push(i)
          }
          if (res.data.data.image) {
            this.imglist = res.data.data.image
          }
          if (res.data.data.cover) {
            this.imglist.unshift(res.data.data.cover)
          }
          this.imgnum=this.imglist.length
        }
      })
    },
    changeimg(index){
      this.imgindex=index+1
    },
    showImg(key,type){
      this.imagelist =[]
      if(type==0){
        this.imagelist = [this.info.cover]
        this.imgIndex = key
        this.showState = true
      }else{
        this.imagelist = this.imglist
        this.imgIndex = key
        this.showState = true
      }

    },
    changeImg (index) {
      this.imgIndex = index
    },
    adminDel(){
      Dialog.alert({
        message: '确认管理员删除',
        showCancelButton:true,
        confirmButtonColor:'#005DA3',
      }).then(() => {
        admin.delBbs(this.bbs_id).then(res => {
          if(res.data.state == 1){
            Toast.success('删除成功');
            this.$router.go(-1);
            localStorage.setItem('bbslistabc', this.bbs_id)
          }
        })
      })
    },
    adminAudit(type){
      if(type==1){
        var message='确认审核通过'
      }else{
        var message='确认审核不通过'
      }
      Dialog.alert({
        message: message,
        showCancelButton:true,
        confirmButtonColor:'#005DA3',
      }).then(() => {
        var params={
          id:this.bbs_id,
          type:type
        }
        admin.BbsAudit(params).then(res => {
          if(res.data.state == 1){
            Toast.success('审核成功');
            this.$router.go(-1);
            localStorage.setItem('bbslistabc', this.bbs_id)
          }
        })
      })
    },
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [List.name]: List,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Divider.name]:Divider,
    [Grid.name]:Grid,
    [GridItem.name]:GridItem,
    [Field.name]:Field,
    [Icon.name]:Icon,
    [Overlay.name]:Overlay,
    [ImagePreview.name]:ImagePreview,
    [Lazyload.name]:Lazyload,
    [ActionSheet.name]:ActionSheet,
    [Dialog.name]:Dialog,
    [Toast.name]:Toast
  }
};
</script>

<style lang="scss">
.bbsinfo {
  margin-bottom: 50px;
  background-color: #F0F0F0;
  .toppicbox{
    width: 100%;
    height: 250px;
    object-fit: cover;
  }
  .piclength{
    width: 30px;
    float: right;
    margin-right: 10px;
    margin-top: -25px;
    position: relative;
    font-size: 10px;
    color: #fff;
    background-color: #000000;
    opacity: 0.5;
    text-align: center;
  }
  .topimg{
    width: 100%;
    height: 250px;
    margin-bottom: 20px;
    object-fit: cover;
  }
  .img {
    width: 100%;
    display: block;
    margin-top: 10px;
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
    vertical-align: middle;
  }
  .show {
    padding: 10px 0;
    overflow: hidden;
    background-color: #FFF;
    .listhand{
      width:40px;
      height:40px;
      border-radius: 1.5px;
    }
    .infohand_box{
      width:40px;
      height:40px;
      position: relative;
    }
    .infohand_border{
     width:40px;
     height:40px;
     position: absolute;
     left: 0;
   }
   .ml-10{
    margin-left: 10px;
  }
  .membername{
    font-size: 15px;
    font-weight: bold;
  }
  .activename{
    font-size: 14px;
    font-weight: bold;
    line-height: 3;
    color: #605C6B;
  }
  .van-row{
    padding: 0 10px;
  }
  h1 {
    padding: 0 10px;
    margin-top: 20px;
    font-size: 16px;
    word-break:break-all;
  }
  p {
    padding: 0 10px;
    margin: 0;
    font-size: 14px;
    margin-top: 20px;
    line-height: 25px;
    word-break:break-all;
  }
  .van-tag{
    font-size: 12px;
    margin-right: 5px;
  }
  .tip {
    text-align: right;
  }
  .tag{
    padding: 5px 10px;
  }
  .divider{
    font-size: 13px;
    margin: 20px 80px;
  }
  .van-icon__image{
    width: 24px;
    height: 20px;
  }
}

}
.bbsbottom{
  position:fixed;
  bottom:0;
  font-size: 12px;
  color: #0C08BF;
  background-color:#fff;
  text-align: right;
  width: 100%;
  padding: 15px 0;
  span{
    margin-right: 15px;
    text-decoration: underline;
  }
}
</style>
